var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.sustainability = pt.blocografico.modules.sustainability || {};
pt.blocografico.modules.sustainability = (function () {
  function init() {
    let elementsToUpdate = document.querySelectorAll(".numbers-to-grow");
    pt.blocografico.library.counter.updateCounters(elementsToUpdate, 50);
    initlizeSliders();
  }

  function initlizeSliders() {
    let sliders = document.querySelectorAll(".sustainability-slider");
    sliders.forEach(function (element) {
      const smooth = element.dataset.smooth !== undefined ? parseInt(element.dataset.smooth, 10) : 0;
      pt.blocografico.library.createCarousel(`#${element.id}`, {
        autoplay: true,
        interval: 2500,
        clickable: true,
        smooth,
      });
    });
  }
  return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
  pt.blocografico.modules.sustainability.init();
});
